import script from "./phoneComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./phoneComponent.vue?vue&type=script&setup=true&lang=js"

import "./phoneComponent.vue?vue&type=style&index=0&id=3579086a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3579086a"]])

export default __exports__